import React from "react";
import WebPicture from "../../layout/WebPicture";
import "./LatestBlogPosts.scss";
import { NavLink } from "react-router-dom";
import { formatDateToString } from "../../utils/helpers";

const LatestBlogPosts = ({ data, heading, preTitle }) => {
  return (
    data?.posts && (
      <section className="latest-blog-posts-section">
        <div className="container">
          <div className="row">
            {preTitle && (
              <div className="col-12">
                <h6>{preTitle}</h6>
              </div>
            )}
            <div className="col-12">
              <h2>{heading || "More from our blog"}</h2>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="posts-list row">
                {Object.keys(data.posts).map((i) => {
                  const thumbnail = {
                    webp: data.posts[i].image[1],
                    img: data.posts[i].image[0],
                    title: data.posts[i].title?.rendered,
                    class: "blog-post-image",
                  };

                  return (
                    <div key={i} className="blog-post col-4">
                      <NavLink to={data.posts[i].link}>
                        <div className="thumbnail">
                          <WebPicture data={thumbnail} />
                        </div>
                        <div className="blog-meta">
                          <span className="date-published">
                            {formatDateToString(data.posts[i]?.date)}
                          </span>
                          {data.posts[i].categories_name?.length ? (
                            <span></span>
                          ) : (
                            ""
                          )}
                          {data.posts[i].categories_name?.length
                            ? data.posts[i].categories_name.map(
                                (category, j) => {
                                  const style = {
                                    "--color": category?.color || "#009FE3",
                                  };

                                  return (
                                    <span key={j} style={style}>
                                      {category.name}
                                    </span>
                                  );
                                }
                              )
                            : ""}
                        </div>
                        <h3>{data.posts[i].title?.rendered}</h3>
                        <div className="blog-excerpt">
                          {data.posts[i].excerpt?.rendered}
                        </div>
                      </NavLink>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default LatestBlogPosts;
